import React, { useState,useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

const TrialActivationModal = (props) => {
  const show = true;

  const handleClose = () => props.close();
 

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Activate Your Free Trial</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          To access this service, please activate your free trial. <a href="/webinars/pay-now">Pay Now</a>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {/* Add a button here to activate the trial */}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TrialActivationModal;
